import { FC } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import {
  ErrorOutline as ErrorOutlineIcon,
  InsertLink as InsertLinkIcon,
  LinkOff as LinkOffIcon,
} from "@material-ui/icons";

import { ASSET_STATE_TO_USER_INFO } from "services/assets/constants";
import { AssetState } from "services/assets/types";
import theme from "theme";

const useStyles = makeStyles({
  icon: {
    fontSize: "15px",
    marginRight: "3px",
  },
  yellowIcon: {
    color: theme.custom.palette.yellow.main,
  },
  redIcon: {
    color: theme.custom.palette.red.main,
  },
  greenIcon: {
    color: theme.custom.palette.green.main,
  },
});

interface CredentialSubmissionStatusProps {
  assetState: AssetState;
}
const CredentialSubmissionStatus: FC<CredentialSubmissionStatusProps> = ({
  assetState,
}) => {
  const classes = useStyles();
  const renderIcon = () => {
    const warningIconStates = [
      "failed_auto_unqualified",
      "failed_unqualified",
      "undefined",
    ];
    const errorIconStates = [
      "failed_login_invalid_credentials",
      "failed_login_2fa_block",
      "failed_need_credentials_update",
    ];
    const successIconStates = [
      "qualified",
      "awaiting_review",
      "awaiting_valuation",
    ];

    if (warningIconStates.includes(assetState)) {
      return (
        <ErrorOutlineIcon className={`${classes.icon} ${classes.yellowIcon}`} />
      );
    }
    if (errorIconStates.includes(assetState)) {
      return <LinkOffIcon className={`${classes.icon} ${classes.redIcon}`} />;
    }
    if (successIconStates.includes(assetState)) {
      return (
        <InsertLinkIcon className={`${classes.icon} ${classes.greenIcon}`} />
      );
    }
    return null;
  };

  return (
    <Box display="flex" alignItems="center">
      {renderIcon()}
      <Box ml={0.5}>
        <Typography
          color="primary"
          variant="body1"
          component="div"
          style={{ fontSize: "0.8rem", lineHeight: 1.4 }}
        >
          {ASSET_STATE_TO_USER_INFO[assetState].headerMessage}
        </Typography>
      </Box>
    </Box>
  );
};
export default CredentialSubmissionStatus;
